import { applyTextDiff, updateBlockProps } from "@worktools/shared";
import { useBlockProps, useYText } from "../../sync/hooks";
import { useBoard } from "../../sync/BoardContext";

const SIZES: Record<string, { fontSize: number; fontWeight: number; lineHeight: number }> = {
  display: { fontSize: 30, fontWeight: 600, lineHeight: 1.15 },
  heading: { fontSize: 20, fontWeight: 500, lineHeight: 1.25 },
  body: { fontSize: 14, fontWeight: 400, lineHeight: 1.6 },
};

export function TextBlock({ blockId }: { blockId: string }) {
  const { doc } = useBoard();
  const props = useBlockProps<{ size: string }>(blockId);
  const { text, value } = useYText(blockId, "text");
  const style = SIZES[props.size] ?? SIZES.body;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8, height: "100%" }}>
      <div style={{ display: "flex", gap: 4 }}>
        {Object.keys(SIZES).map((size) => (
          <button
            key={size}
            className={`pill${props.size === size ? " pill--solid" : ""}`}
            onClick={() => updateBlockProps(doc, blockId, { size })}
          >
            {size === "display" ? "Titel" : size === "heading" ? "Überschrift" : "Fließtext"}
          </button>
        ))}
      </div>
      <textarea
        value={value}
        placeholder="Text schreiben…"
        onChange={(event) => text && applyTextDiff(text, event.target.value)}
        style={{ flex: 1, border: "none", background: "none", resize: "none", outline: "none", padding: 0, ...style }}
      />
    </div>
  );
}
